import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Button, Col, Modal, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { FiEdit, FiEye } from "react-icons/fi";
import {
  getAllEscalationEventEvent,
  updateEmailTemplate,
} from "app/_services/ehs/ehsCapaServices";

import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { escalationEventLabel } from "app/_constants/constant";
import { BsFillInfoCircleFill } from "react-icons/bs";
import { useForm } from "app/_helpers/hooks";
import toastr from "toastr";

const ManageEmailTemplate = ({
  match: {
    params: { siteId },
  },
  user,
}) => {
  const [capas, setCapas] = useState([]);
  const [showManageModal, setShowManageModal] = useState(false);
  const [defaultTem, setDefaultTem] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [modalData, onChange, setModalData] = useForm({});

  const sortableColumn = [
    {
      dataField: "sid",
      text: "S.No.",
      sort: true,
    },
    {
      dataField: "event",
      text: "Event Type",
      sort: true,
      formatter: (id, row) => escalationEventLabel[row?.event] || "",
    },
    {
      dataField: "subject",
      text: "Subject",
      sort: true,
    },

    {
      dataField: "id",
      text: "Action",
      formatter: (id, row) => {
        return (
          <div className="actionIconsGroup">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-top">View</Tooltip>}
            >
              <span
                className="icons text-cyanBlue"
                onClick={() => {
                  setShowManageModal(true);
                  setDefaultTem(false);
                  setModalData(row);
                }}
              >
                <FiEye />
              </span>
            </OverlayTrigger>

            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-top">Update</Tooltip>}
            >
              <Link
                to={
                  (siteId ? `/sites/${siteId}` : "") +
                  "/admin-panel/manage-email-template/update/" +
                  id
                }
                className="icons text-cyanBlue"
              >
                <FiEdit />
              </Link>
            </OverlayTrigger>

            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-top">Default Email Template</Tooltip>}
            >
              <span
                className="icons"
                onClick={() => {
                  setShowManageModal(true);
                  setDefaultTem(true);
                  setModalData(row);
                }}
              >
                <BsFillInfoCircleFill />
              </span>
            </OverlayTrigger>
          </div>
        );
      },
    },
  ];

  const fetchData = useCallback(() => {
    getAllEscalationEventEvent(siteId ? `filter[siteId]=${siteId}` : "").then(
      (response) => {
        if (!response?.data) return;
        setCapas(response.data.map((data, index) => ({ ...data, sid: index + 1 })));
      }
    );
  }, [siteId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const onSubmit = async () => {
    const response = await updateEmailTemplate(
      modalData?.id,
      modalData,
      `?defaultTemplate=${true}`
    );

    if (!response?.status) return toastr.error(response?.message);
    toastr.success("Success");
    setShowManageModal(false);
    setEditMode(false);
    setModalData({});
    fetchData();
  };

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "Admin Panel", path: "#" },
          { name: "Manage Email Template", path: "#" },
        ]}
        breadCrumbsText="User_Management_User_Registration"
      />
      <div className="healthSafetyEnvironmentWrapper">
        <div className="p-2">
          <div className="card p-3 mt-3">
            <div className="simple-card-title">
              <h3 className="text-capitalize mb-1">Manage Email Template</h3>
            </div>
            <>
              <SearchBootstrapTable
                data={capas}
                columns={sortableColumn}
                // tableDownloadFlag={false}
              />
            </>
          </div>
        </div>
      </div>
      <Modal show={showManageModal} backdrop="static" size="lg">
        <div className="card" style={{ overflow: "visible" }}>
          <div className="card-body">
            <div className="d-flex align-items-center justify-content-between simple-card-title">
              <h3 className="text-capitalize mb-1">{`${
                defaultTem ? "Default" : "View"
              } Email Template`}</h3>
              {defaultTem && (
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip-top">
                      {editMode ? "Edit Mode Off" : "Edit Mode On"}
                    </Tooltip>
                  }
                >
                  <span
                    className={`icons ${editMode ? "text-cyanBlue" : "text-muted"} mr-3`}
                    onClick={() => setEditMode(!editMode)}
                  >
                    <FiEdit size={18} />
                  </span>
                </OverlayTrigger>
              )}
            </div>
            {!defaultTem ? (
              <Row className="mb-3">
                <Col md={12} className="drilingView-bx">
                  <h5>Event Type</h5>
                  <p>{escalationEventLabel[modalData?.event] || ""}</p>
                </Col>
                <Col md={12} className="drilingView-bx">
                  <h5>Subject</h5>
                  <p>{modalData?.subject}</p>
                </Col>
                <Col md={12} className="drilingView-bx">
                  <h5>Notification Message</h5>
                  <p>{modalData?.notificationMessage}</p>
                </Col>

                <Col md={12} className="drilingView-bx">
                  <h5>Email Template</h5>
                  <div className="emailContent">
                    <p
                      dangerouslySetInnerHTML={{
                        __html: modalData?.emailTemplate,
                      }}
                    ></p>
                  </div>
                </Col>
              </Row>
            ) : (
              <ViewDefaultTemplate
                form={modalData}
                editMode={editMode}
                onChange={onChange}
              />
            )}
            <div className="mt-2 text-center">
              <Button
                onClick={() => {
                  setShowManageModal(false);
                  setEditMode(false);
                }}
                className="btn btn-secondary mr-2"
              >
                Close
              </Button>

              {defaultTem && editMode && (
                <Button
                  onClick={() => onSubmit()}
                  variant="primary"
                  className="m-1 text-capitalize"
                >
                  Save
                </Button>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default connect((state) => ({ user: state.user.user }))(ManageEmailTemplate);

export const ViewDefaultTemplate = ({ form, editMode, onChange }) => {
  let dynamicVariables = "";
  if (form?.dynamicVariables) {
    dynamicVariables = Object.keys(form?.dynamicVariables)
      ?.map((x) => x)
      .join(", ");
  }

  return (
    <div className="ehsFormWrapper">
      <Row>
        <Col lg={4}>
          <div className="form-group viewbox">
            <h5 className="w-500 mb-1">Event Type</h5>
            <input
              name="event"
              value={escalationEventLabel[form?.event]}
              className="form-control"
              readOnly
            />
          </div>
        </Col>

        <Col lg={12}>
          <div className="form-group viewbox">
            <h5 className="w-500 mb-1">Subject</h5>
            <input
              value={form?.defaultSubject}
              name="defaultSubject"
              class="form-control"
              placeholder="Max 1000 Characters"
              maxLength={1000}
              readOnly={!editMode}
              onChange={onChange}
            />
          </div>
        </Col>
        <Col lg={12}>
          <div className="form-group viewbox">
            <h5 className="w-500 mb-1">Notification Message</h5>
            <textarea
              value={form?.defaultNotificationMessage}
              name="defaultNotificationMessage"
              class="form-control"
              style={{ height: "150px" }}
              placeholder="Max 1000 Characters"
              maxLength={1000}
              readOnly={!editMode}
              onChange={onChange}
            />
          </div>
        </Col>
        <Col lg={12}>
          <div className="form-group viewbox">
            <h5 className="w-500 mb-1">Email Template</h5>
            <textarea
              value={form?.defaultEmailTemplate}
              name="defaultEmailTemplate"
              class="form-control"
              style={{ height: "150px" }}
              placeholder="Max 1000 Characters"
              maxLength={2000}
              readOnly={!editMode}
              onChange={onChange}
            />
          </div>
          <span>*{dynamicVariables}</span>
        </Col>
      </Row>
    </div>
  );
};
